module.exports = __webpack_public_path__ + "static/media/master_setting.d58ff240.svg";